import { Outlet } from 'react-router-dom'
import { Header } from '@/components/header'
import { Footer } from '@/components/footer'

export function MainLayout() {
    return (
        <>
            <Header />
            <main className="min-h-screen">
                <Outlet />
            </main>
            <Footer />
        </>
    )
}
